import { atom } from "recoil"

import type { Company } from "interfaces/CompanyIF"

export const companyState = atom<Company | null>({
  key: "companyState",
  default: null,
})
